import {Component, Input, Output, EventEmitter} from '@angular/core';
import {AppointmentRequest} from '@shared/models/appointment-request.model';

@Component({
  selector: 'si-appo-appointment-request-finish-error',
  templateUrl: './appo-appointment-request-finish-error.component.html',
  styleUrls: ['./appo-appointment-request-finish-error.component.scss']
})
export class AppoAppointmentRequestFinishErrorComponent {
  @Input() model = new AppointmentRequest();
  @Input() textError: string;
  @Input() finishError: boolean;
  @Input() currentStep: number;
  @Output() finishErrorChange = new EventEmitter<boolean>();
  @Output() currentStepChange = new EventEmitter<number>();

  onClickRequestAgain(): void {
    this.model.reserveId = null;
    this.currentStepChange.emit(0);
    this.finishErrorChange.emit(false);
  }
}
